import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Button,
  Checkbox,
  Row,
  Col,
  Typography,
  Card,
  message,
  Divider,
} from "antd";
import Swal from 'sweetalert2';
import { SendOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from '../../App';
import { Collapse } from 'antd';
import { Spin } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
const { Option } = Select;
const { Title } = Typography;

const ServiceClaimWWF = () => {
  const [form] = Form.useForm();
  const [branches, setBranches] = useState([]);
  const [ascTypes, setAscTypes] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [dealerCodes, setDealerCodes] = useState([]);
  const [psgOptions, setPsgOptions] = useState([]);
  const [filteredPsgOptions, setFilteredPsgOptions] = useState([]);
  const [psgGrids, setPsgGrids] = useState([]);

  const [loading, setLoading] = useState(false);
  const handleSendForApproval = async () => {
    try {
      
      const formValues = await form.validateFields();
      const { branch, dealerCode, psgs } = formValues;
  
      const rates = {};
      psgGrids.forEach((psgGrid) => {
        const psg = psgGrid.psg;
        if (!psgs.includes(psg)) return;
  
        rates[psg] = {};
        psgGrid.hpList.forEach((item, idx) => {
          const inputElem = document.querySelector(`#psg_${psg}_hp_${idx}`);
          if (inputElem) {
            rates[psg][item.hp] = inputElem.value?.trim() || "0";
          }
        });
      });
      setLoading(true);
      await axios.post(`${BASE_URL}/submitforrewindingfixation`, {
        branch,
        dealer_code: dealerCode,
        selectedPsgs: psgs,
        rates,
      });
  
      setPsgGrids([]);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Sent for approval!',
        confirmButtonColor: '#3085d6'
      });
    } catch (err) {
      const errorMessage = err?.response?.data?.error || 'Validation or submission failed';
      Swal.fire({
        icon: 'info',
        text: errorMessage,
        confirmButtonColor: '#d33'
      });
    } finally {
      setLoading(false);
    }
  };
  
  
  
  const handleViewClick = async () => {
    const branch = form.getFieldValue('branch');
    const dealerCode = form.getFieldValue('dealerCode');
    const psgs = form.getFieldValue('psgs');
  
    if (!branch ) {
      Swal.fire({
        icon: 'info',
        //title: 'Missing Required Fields',
        text: 'Please select Branch',
        confirmButtonColor: '#3085d6'
      });
      return;
    }
    if ( !dealerCode ) {
      Swal.fire({
        icon: 'info',
       // title: 'Missing Required Fields',
        text: 'Please select Service Center',
        confirmButtonColor: '#3085d6'
      });
      return;
    }
    if ( !psgs || psgs.length === 0) {
      Swal.fire({
        icon: 'info',
       // title: 'Missing Required Fields',
        text: 'Please select at least one PSG before viewing.',
        confirmButtonColor: '#3085d6'
      });
      return;
    }
  
    try {
      setLoading(true); 
      const response = await axios.post(`${BASE_URL}/psgforselecting`, {
        branch,
        dealerCode,
        psgs,
      });
      setPsgGrids(response.data);
    } catch (error) {
      console.error("Error fetching PSG grid:", error);
      // message.error("Failed to fetch PSG details.");
    } finally {
      setLoading(false);
    }
  };
  
  
  
  const login_id = localStorage.getItem("LOGIN_ID");
  const user_branch = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");
  useEffect(() => {
    setLoading(true); 
    axios.post(`${BASE_URL}/branchesforrewindingfixation`, {
      login_id: login_id,
      user_branch: user_branch
    })
    .then((res) => {
      setBranches(res.data);
    })
    .catch((err) => {
      console.error("Failed to load branches:", err);
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Error',
      //   text: 'Failed to load branches.',
      //   confirmButtonColor: '#d33'
      // });
    })
    .finally(() => {
      setLoading(false); 
    });
  }, []);
  



  const handleDealerCodeChange = (value) => {
    setPsgGrids([]);
    form.setFieldsValue({ psgs: [] });
   // axios.get(`/api/psgs?dealerCode=${value}`).then((res) => setPsgOptions(res.data));
  };

  useEffect(() => {
   
    setAscTypes([
      { value: "CASC", label: "CASC" },
      { value: "DASC", label: "DASC" },
    ]);
  
    
    setProcesses([
      { value: "NEW", label: "NEED TO FRESH ENTRY" },
      { value: "MODIFY", label: "ALREADY SENT ENTRY" },
      { value: "REJECTED", label: "REJECTED ENTRY" },
    ]);
  }, []);
  const handleProcessChange = (processValue) => {
    setPsgGrids([]);
    setDealerCodes([]);
    form.setFieldValue('dealerCode', '');
    form.setFieldsValue({ psgs: [] });

    const ascType = form.getFieldValue("ascType");
    const branch = form.getFieldValue("branch");
    if (!ascType) {
      Swal.fire({
        icon: "info",
        title: "Missing ASC Type",
        text: "Please select ASC Type before choosing a Process.",
        confirmButtonColor: "#3085d6"
      });
  
      form.setFieldsValue({ process: undefined });
      return;
    }
  
    if (!branch) {
      Swal.fire({
        icon: "info",
        title: "Missing Branch",
        text: "Please select Branch before choosing a Process.",
        confirmButtonColor: "#3085d6"
      });
  
      form.setFieldsValue({ process: undefined });
      return;
    }
  
    form.setFieldsValue({ dealerCode: undefined });
    setDealerCodes([]);
    setLoading(true);
  
    axios
      .post(`${BASE_URL}/ascforrewindingfixation`, {
        process: processValue,
        ascType: ascType,
        branch: branch
      })
      .then((res) => {
        setDealerCodes(res.data);
      })
      .catch((error) => {
        console.error("Failed to fetch dealers:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load dealers.",
          confirmButtonColor: "#d33"
        });
      })
      .finally(() => {
        setLoading(false); 
      });
  };

  const ascTypee = Form.useWatch("ascType", form);
  const branchh = Form.useWatch("branch", form);
  const processValuee = Form.useWatch("process", form);
useEffect(() => {
  
  if (!branchh || !processValuee || !ascTypee) return;

  setLoading(true); 

  axios
    .post(`${BASE_URL}/ascforrewindingfixation`, {
      process: processValuee,
      ascType: ascTypee,
      branch: branchh
    })
    .then((res) => {
      setDealerCodes(res.data);
    })
    .catch((error) => {
      console.error("Failed to fetch dealers:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load dealers.",
        confirmButtonColor: "#d33"
      });
    })
    .finally(() => {
      setLoading(false);    });

}, [branchh, ascTypee]); 

  
  useEffect(() => {
    setLoading(true);
  
    axios.post(`${BASE_URL}/loadpsgg`)
      .then((res) => setPsgOptions(res.data))
      .catch((err) => {
        console.error("Error loading PSGs on page load:", err);
      //  message.error("Failed to load PSG options.");
      })
      .finally(() => {
        setLoading(false); 
      });
  }, []);
  
  
const getPsgName = (psgId) => {
  const match = psgOptions.find(p => p.id === psgId);
  return match ? match.name : psgId;
};

  return (
    <div className="container mx-auto px-4">
      <div className="px-6 py-10 max-w-6xl mx-auto bg-gradient-to-br from-indigo-100 via-white to-green-100 rounded-3xl shadow-xl">
        {/* <Title level={2} className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-blue-700 text-center mb-10 font-extrabold uppercase tracking-wide">
          Winding Wire Fixation
        </Title> */}
       
        <Card bordered={false} className="rounded-2xl shadow-md bg-white p-6">
          <Form form={form} layout="vertical" initialValues={{ remember: true }}>
            <Row gutter={[24, 16]}>
              <Col span={12}>
              <Form.Item
  label={<span style={{ fontWeight: 'bold' }}>Branch</span>}
  name="branch"
  rules={[{ required: true, message: 'Please select a branch' }]}
>
  <Select
    placeholder="Select Branch"
    size="large"
    onChange={(value) => {
      form.setFieldValue('branch', value); 
      setPsgGrids([]);   
      setDealerCodes([]); 
      form.setFieldValue('dealerCode', '');   
      form.setFieldsValue({ psgs: [] });               
    }}
  >
    {branches.map((b) => (
      <Option key={b.code} value={b.code}>
        {b.code} - {b.name}
      </Option>
    ))}
  </Select>
</Form.Item>

              </Col>
              <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 'bold' }}>ASC Type</span>} name="ascType" rules={[{ required: true, message: 'Please select ASC type' }]}>
  <Select placeholder="Select ASC Type" size="large"
  onChange={(value) => {
    form.setFieldValue('ascType', value); 
    setPsgGrids([]);   
    setDealerCodes([]); 
     form.setFieldValue('dealerCode', ''); 
     form.setFieldsValue({ psgs: [] });                   
  }}>
 
    {ascTypes.map((type) => (
      <Option key={type.value} value={type.value}>{type.label}</Option>
    ))}
  </Select>
</Form.Item>



              </Col>
            </Row>

            <Row gutter={[24, 16]}>
              <Col span={12}>
              <Form.Item
 label={<span style={{ fontWeight: 'bold' }}>Process</span>}
  name="process"
  rules={[{ required: true, message: 'Please select process' }]}
>
  <Select
    placeholder="Select Process"
    size="large"
    onChange={handleProcessChange} 
  >
    {processes.map((p) => (
      <Option key={p.value} value={p.value}>{p.label}</Option>
    ))}
  </Select>
</Form.Item>

              </Col>
              <Col span={12}>
              <Form.Item
 label={<span style={{ fontWeight: 'bold' }}>Service Center</span>}
  name="dealerCode"
  rules={[{ required: true, message: 'Please select Service Center' }]}
>
  <Select
    placeholder="Select Dealer Code"
    size="large"
    onChange={handleDealerCodeChange}
    showSearch
    optionFilterProp="children"
  >
    {dealerCodes.map((d) => (
      <Option key={d.dealer_code} value={d.dealer_code}>
        {d.dealer_code} - {d.dealername}
      </Option>
    ))}
  </Select>
</Form.Item>

              </Col>
            </Row>

            <Divider orientation="left" plain className="text-teal-600 font-semibold text-lg">
            {<span style={{ fontWeight: 'bold' }}>PSG Options</span>}
</Divider>

{/* Search box for PSGs */}
<Form.Item label={<span style={{ fontWeight: 'bold' }}>Search PSG</span>}>
  <input
    type="text"
    placeholder="Search PSG..."
    className="w-full px-3 py-2 border border-gray-300 rounded-md"
    onChange={(e) => {
      const keyword = e.target.value.toLowerCase();
      const filtered = psgOptions.filter(psg =>
        psg.name.toLowerCase().includes(keyword)
      );
      setFilteredPsgOptions(filtered);
    }}
  />
</Form.Item>

<Form.Item name="psgs">
  <Checkbox.Group style={{ width: '100%' }}>
    <div style={{ maxHeight: '220px', overflowY: 'auto', paddingRight: '10px' }}>
      <Row gutter={[16, 12]}>
        {(filteredPsgOptions.length ? filteredPsgOptions : psgOptions).map(psg => (
          <Col span={8} key={psg.id}>
            <Checkbox value={psg.id} className="text-base text-gray-800">
              {psg.name}
            </Checkbox>
          </Col>
        ))}
      </Row>
    </div>
  </Checkbox.Group>
</Form.Item>


            <div className="text-right mt-6">
              <Button
                type="primary"
                icon={<SendOutlined />}
                size="large"
                onClick={handleViewClick}
                className="bg-gradient-to-r from-blue-600 to-blue-800 border-none hover:from-blue-700 hover:to-blue-900 shadow-md"
              >
                View
              </Button>
            </div>
          </Form>
        </Card>

        
    <Card className="mt-10 rounded-2xl shadow-md bg-white overflow-y-auto" style={{ maxHeight: '480px' }}>
      <Collapse accordion>
        {psgGrids.map((psgGrid, index) => (
          <Panel header={getPsgName(psgGrid.psg)} key={index}>
          
        
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300 text-sm text-center">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-4 py-2">HP</th>
                    <th className="border border-gray-300 px-4 py-2">Amount (Rs.)</th>
                  </tr>
                </thead>
                <tbody>
                {psgGrid.hpList.map((item, idx) => (
  <tr key={idx}>
    <td className="border px-4 py-2">{item.hp}</td>
    <td className="border px-4 py-2">
      <input
        id={`psg_${psgGrid.psg}_hp_${idx}`}
        type="text"
        defaultValue={item.amount || ''}
        className="border px-2 py-1 rounded w-full"
      />
    </td>
  </tr>
))}

                </tbody>
              </table>
            </div>
          </Panel>
        ))}
      </Collapse>
    </Card>





        <div className="text-center mt-10">
        <Button
  type="primary"
  size="large"
  disabled={psgGrids.length === 0}
  loading={loading}
  icon={<CheckCircleOutlined />}
  onClick={handleSendForApproval}
  className="bg-gradient-to-r from-green-500 to-green-700 text-white border-none hover:from-green-600 hover:to-green-800 shadow-md px-6"
>
  Send for Approval
</Button>
        </div>
      </div>
     
      {loading && (
  <div style={{
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)', 
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
    <Spin tip="Loading PSGs..." size="large" />
  </div>
)}
    </div>
  );
};

export default ServiceClaimWWF;
